<template lang="pug">
div(:class="appBarBg" class="tw-absolute tw-self-start tw-pt-5 tw--mt-1 tw-w-full tw-h-16 tw-z-50")
  v-row(justify="space-around" class=" tw-mx-16 ")
    v-col(cols="auto")
      template(v-if="website.logo")
        v-img(:src="path(website.logo)" class="tw-w-24 tw-h-24 tw-shadow-md tw-mx-6")
      template(v-else)
        span(:class="titleColor" class=" tw-text-lg tw-font-bold") realtor
    v-spacer
    v-col(cols="auto")
      v-row(class="tw-text-white tw-font-bold tw-text-sm tw-bg-teal-lighten-3 tw-bg-opacity-75 tw-rounded-full tw-px-2 ")
        v-col(cols="auto" v-if="website.pages.home.published")
          router-link(:to="{ path: '/website' }")
            span(class="tw-text-white tw-uppercase") {{ website.pages.home.name }}
        v-col(v-if="website.pages.rent.published" cols="auto")
          router-link(:to="{ path: '/website/rent' }")
            span(class="tw-text-white tw-uppercase") {{ website.pages.rent.name }}
        v-col(cols="auto" v-if="website.pages.buy.published")
          router-link(:to="{ path: '/website/sale' }")
            span(class="tw-text-white tw-uppercase") {{ website.pages.buy.name }}
        v-col(cols="auto" v-if="website.pages.about.published")
          router-link(:to="{ path: '/website/about' }")
            span(class="tw-text-white tw-uppercase") {{ website.pages.about.name }}
        v-col(cols="auto" v-if="website.pages.contact.published")
          router-link(:to="{ path: '/website/contact' }")
            span(class="tw-text-white tw-uppercase") {{ website.pages.contact.name }}
    v-spacer
</template>
<script>
export default {
  props: {
    appBarBg: {
      type: String,
      default: 'tw-bg-none',
    },
    titleColor: {
      type: String,
      default: 'tw-text-white',
    },
    changeOnScroll: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  mounted() {
    if (this.changeOnScroll == true) {
      document.getElementById('website-theme-preview').onscroll = () => {
        this.appBarChangeColor();
      };
    }
  },
  computed: {
    website() {
      return this.$store.getters['website/website'];
    },
  },
  methods: {
    appBarChangeColor() {
      if (document.body.scrollTop > 100 || document.getElementById('website-theme-preview').scrollTop > 100) {
        this.appBarBg = 'tw-bg-white tw-shadow-lg';
        this.titleColor = 'tw-text-black';
      } else {
        this.appBarBg = 'tw-bg-none';
        this.titleColor = 'tw-text-white';
      }
    },
  },
};
</script>
